import React, { Fragment } from 'react';
import { H1, H3, P, NoTranslate, Header } from '@contently/toolkit';
import SalesForceIntegrationForm from './SalesforceIntegrationForm';
import ContentPortalForm from './ContentPortalForm';
import { post, patch } from '../../utils/api';
import copy from './copy';

function IntegrationFormWrapper(props) {
  const { appData } = props;
  const parsedProps = JSON.parse(appData);
  const { platform, id, method, accountName } = parsedProps;

  const methods = {
    new: { getPath: 'new', savePath: '', apiFunc: post, copy: 'Add' },
    edit: { getPath: id, savePath: id, apiFunc: patch, copy: 'Edit' }
  };

  const renderIntegrationForm = platform => {
    const combinedProps = { ...parsedProps, methods };
    switch (platform) {
      case 'salesforce':
        return <SalesForceIntegrationForm {...combinedProps} />;
      case 'content_portal':
        return <ContentPortalForm {...combinedProps} />;
      default:
        console.error(`Invalid platform type: ${platform}`);
        return null;
    }
  };

  return (
    <Fragment>
      <Header>
        <H1>
          {methods[method].copy} {copy[platform].label}
        </H1>
        <NoTranslate>
          <H3>{accountName}</H3>
        </NoTranslate>
        <P>{copy[platform].details}</P>
      </Header>
      {renderIntegrationForm(platform)}
    </Fragment>
  );
}

export default IntegrationFormWrapper;



// WEBPACK FOOTER //
// ./app/javascript/app/components/integrations/IntegrationFormWrapper.jsx